module.exports = __webpack_public_path__ + "img/mobile5.2280f106.svg";